import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Popover,
  Box,
  Typography,
  Button,
  Grid,
  Badge,
  useMediaQuery,
  IconButton,
  Grid2,
} from "@mui/material";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { AddCircle, Block } from "@mui/icons-material"; // Import the icons
import AddShoppingCartOutlinedIcon from "@mui/icons-material/AddShoppingCartOutlined";
import AddCircleTwoToneIcon from "@mui/icons-material/AddCircleTwoTone";
import {
  setGuestCount,
  setSelectedEventOrStdResType,
  updateDisCountPrice,
  updateTotalCount,
  updateTotalPrice,
} from "../../store/slice/Ticketing.slice";
import GuestCount from "./GuestCount";
import { format_Number } from "../../utils/utils";
import { useTheme } from "@emotion/react";
import ShowMoreLessText from "../horecaWidget/ShowMoreLessText";

const EventOrStandardReservationType = ({ Ref, isOpen, handleClose }) => {
  const theme = useTheme();
  const [isImageValid, setIsImageValid] = useState(false);

  const matchesSm = useMediaQuery("sm");
  const [showMore, setShowMore] = useState(false);
  const { widgetConfig } = useSelector((store) => store?.widgetSettings);
  const {
    EventOrStdTicketTypesData,
    SelectedEventOrStdResType,
    adult,
    child,
    kid,
    baby,
    toddler,
    totalCount,
    reservType,
    TotalPrice,
    disCountPrice,
    selectedDate,
    guestCounts,
  } = useSelector((store) => store?.Ticketing);
  const dispatch = useDispatch();
  const handleSelect = (item) => {
    localStorage?.setItem('idreservation',item?.idreservationtype)
    dispatch(setSelectedEventOrStdResType(item));
    if(item?.idreservationtype != Object.keys(guestCounts)?.[0]){
    dispatch(setGuestCount({
        idreservationtype: item.idreservationtype,
        guestType:"adult",
        count: 1,
      }))
    }
  };
  const calculateTicketingDiscount = () => {
    let quantity = totalCount;
    // Discount configuration (assuming these are coming from state or props)
    const discountConfig = {
      hasDiscountPerTicket1: EventOrStdTicketTypesData?.hasDiscountPerTicket1,
      hasDiscountPerTicket2: EventOrStdTicketTypesData?.hasDiscountPerTicket2,
      discountPercentagePerTicket1:
        EventOrStdTicketTypesData?.discountPercentagePerTicket1,
      discountPercentagePerTicket2:
        EventOrStdTicketTypesData?.discountPercentagePerTicket2,
      numberOfTicketsEligibleForDiscount1:
        EventOrStdTicketTypesData?.numberOfTicketsEligibleForDiscount1,
      numberOfTicketsEligibleForDiscount2:
        EventOrStdTicketTypesData?.numberOfTicketsEligibleForDiscount2,
    };

    let applicableDiscount = 0;
    let eligibleDiscounts = [];

    // Check first discount rule
    if (
      discountConfig.hasDiscountPerTicket1 &&
      quantity >= discountConfig.numberOfTicketsEligibleForDiscount1
    ) {
      eligibleDiscounts.push({
        percentage: discountConfig.discountPercentagePerTicket1,
        threshold: discountConfig.numberOfTicketsEligibleForDiscount1,
      });
    }

    // Check second discount rule
    if (
      discountConfig.hasDiscountPerTicket2 &&
      quantity >= discountConfig.numberOfTicketsEligibleForDiscount2
    ) {
      eligibleDiscounts.push({
        percentage: discountConfig.discountPercentagePerTicket2,
        threshold: discountConfig.numberOfTicketsEligibleForDiscount2,
      });
    }

    // Find the best discount (highest percentage)
    if (eligibleDiscounts.length > 0) {
      eligibleDiscounts.sort((a, b) => b.percentage - a.percentage);
      applicableDiscount = eligibleDiscounts[0].percentage;
    }

    const discountAmount = TotalPrice * (applicableDiscount / 100);
    const finalPrice = TotalPrice - discountAmount;
    dispatch(updateDisCountPrice(parseFloat(finalPrice).toFixed(2)));
  };
  const calculateTotalPrice = () => {
    let totalPrice = 0;
    const guestCount =
      guestCounts[SelectedEventOrStdResType?.idreservationtype] || {};
    const { adult = 1, child = 0, kid = 0, baby = 0, toddler = 0 } = guestCount;
    if (reservType?.isStandardTicket && Object.keys(guestCount)?.length > 0) {
      totalPrice =
        adult * SelectedEventOrStdResType?.dayProductPrice1 +
        child * SelectedEventOrStdResType?.dayProductPrice2 +
     // child * 1 +
        kid * SelectedEventOrStdResType?.dayProductPrice3 +
        baby * SelectedEventOrStdResType?.dayProductPrice4 +
        toddler * SelectedEventOrStdResType?.dayProductPrice5;
      dispatch(updateTotalPrice(totalPrice));
    } else {
      totalPrice = adult * SelectedEventOrStdResType?.eventProductPrice;
      dispatch(updateTotalPrice(totalPrice));
    }
  };
  
  useEffect(() => {
    if (SelectedEventOrStdResType?.idreservationtype) {

      calculateTotalPrice();
      calculateTicketingDiscount();
    }
  }, [totalCount, SelectedEventOrStdResType, guestCounts]);



  useEffect(() => {
    if (EventOrStdTicketTypesData?.ticketTypeForReservations?.length == 1) {
      handleSelect(EventOrStdTicketTypesData?.ticketTypeForReservations[0]);

    }
  }, [EventOrStdTicketTypesData?.ticketTypeForReservations]);

  return (
    <Popover
      open={isOpen}
      anchorEl={Ref}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      PaperProps={{
        sx: {
          width: matchesSm ? "93%" : "100%",
          maxWidth: "800px",
        },
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          width: { xs: "100%", sm: "100%", md: "100%" },
          p: 3,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "1rem",
        }}
      >
        {EventOrStdTicketTypesData?.ticketTypeForReservations?.map((item,index) => (
          <>
            <Box
              key={item?.name}
              sx={{
                position: "relative",
                display: "flex",
                flexDirection: { xs: "column", sm: "column", md: "row" },
                gap: "0.5rem",
                p: 1,
                borderRadius: "8px",
                position: "relative",
                    minHeight: "450px",

                backgroundColor:
                  SelectedEventOrStdResType?.name === item?.name
                    ? theme?.resType?.itemBgActive
                    : theme?.resType?.itemBgColor,
                border: `1px solid ${theme?.resType?.borderColor}`,
                p: 2,
                borderRadius: "8px",
                cursor: "pointer",
                color:
                  SelectedEventOrStdResType?.name === item?.name
                    ? theme?.resType?.textColorActive
                    : theme?.resType?.itemTextColor,
                width: "100%",
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                  backgroundColor: theme?.resType?.itemBgHover,
                  color: theme?.resType?.textHover,
                },
              }}
            >
              <Grid container alignItems={"flex-start"} spacing={2}>
                {item?.imageFileName && (
                  <Grid item xs={12} sm={5} md={5}>
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        maxHeight: "200px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "12px",
                        overflow: "hidden", // Ensures the image doesn't overflow

                        transition: "box-shadow 0.3s ease-in-out", // Smooth transition for shadow
                        "&:hover": {
                          boxShadow: "rgba(0, 0, 0, 0.25) 0px 6px 20px", // Stronger shadow on hover
                        },
                        minHeight: "150px", // Maintain at least 150px height for better responsiveness
                      }}
                    >
                      <img
                        src={
                          `https://dashboard.jimani.online/upload/ReservationType/${item?.imageFileName}` ||
                          item?.imageFileName
                        }
                        alt="res-type-img"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover", // To make the image cover the entire area without distortion
                          objectPosition: "center", // Center the image inside the container
                          borderRadius: "12px", // Rounded corners for the image
                          transition: "transform 0.3s ease-in-out", // Smooth zoom effect
                          cursor: "pointer", // Change cursor to indicate interactivity
                        }}
                        onLoad={() => {
                          setIsImageValid(true); // Confirm valid image
                        }}
                        onError={(error) => {
                          setIsImageValid(false); // Mark image as invalid
                        }}
                      />
                    </Box>
                  </Grid>
                )}

                <Grid
                  item
                  xs={12}
                  sm={item?.imageFileName && isImageValid ? 7 : 12}
                  md={item?.imageFileName && isImageValid ? 7 : 12}
                >
                  <Box sx={{ p: 1, width: "100%" }}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "600",
                        }}
                      >
                        {item?.name}
                      </Typography>
                      {(SelectedEventOrStdResType?.idreservationtype ===
                        item?.idreservationtype &&
                        EventOrStdTicketTypesData?.hasDiscountPerTicket1 &&
                        totalCount >=
                          EventOrStdTicketTypesData?.numberOfTicketsEligibleForDiscount1) ||
                      (EventOrStdTicketTypesData?.hasDiscountPerTicket2 &&
                        totalCount >=
                          EventOrStdTicketTypesData?.numberOfTicketsEligibleForDiscount2) ? (
                        TotalPrice > 0 && (
                          <Box>
                            <span
                              style={{
                                textDecorationLine: "line-through",
                                marginRight: "0.3rem",
                              }}
                            >
                              &euro;{format_Number(TotalPrice)}
                            </span>
                            <span style={{ fontSize: "1rem", color: "#fff" }}>
                              &euro; {format_Number(disCountPrice)} off %
                            </span>
                          </Box>
                        )
                      ) : (
                        <Typography>
                          {" "}
                          &euro;{" "}
                          {format_Number(
                            TotalPrice &&
                              SelectedEventOrStdResType?.idreservationtype ===
                                item?.idreservationtype
                              ? TotalPrice
                              : item?.dayProductPrice1 * adult
                          )}
                        </Typography>
                      )}
                    </Box>
                    {item?.info && (
                      <ShowMoreLessText
                        text={item?.info}
                        setIsShowMore={() => setShowMore(!showMore)}
                        isShowMore={showMore}
                        style={{
                          color:
                            SelectedEventOrStdResType?.name === item?.name
                              ? theme?.product?.itemTextActive
                              : theme?.product?.itemText,
                          fontSize: "1.2rem",
                        }}
                      />
                    )}
                  </Box>
                </Grid>
                <Grid item md={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-start",
                    }}
                  >
                    <GuestCount item={item} handleSelect={handleSelect} />
                  </Box>
                </Grid>
              </Grid>
              <Box
                sx={{
                  position: "absolute",
                  bottom: 10,
                  right: 10,
           
                }}
              >
                {EventOrStdTicketTypesData?.showMessageWhenTicketsLessFlag &&
                  SelectedEventOrStdResType?.maximumTickets -
                    SelectedEventOrStdResType?.soldTickets <
                    EventOrStdTicketTypesData?.showMessageWhenTicketsLessThan && (
                    <Box>
                      <Typography>{` Only ${
                        SelectedEventOrStdResType?.maximumTickets -
                        SelectedEventOrStdResType?.soldTickets
                      } tickets are available `}</Typography>
                    </Box>
                  )}
                <IconButton
                  size="small"
                  sx={{
                    borderRadius: "7px",
                    backgroundColor:
                      SelectedEventOrStdResType?.name === item?.name
                        ? theme?.resType?.chooseBgActive
                        : theme?.resType?.chooseBg,
                    color:
                      SelectedEventOrStdResType?.name === item?.name
                        ? theme?.resType?.chooseTextActive
                        : theme?.resType?.chooseText,
                    "&:hover": {
                      backgroundColor: theme?.resType?.chooseBgHover,
                      color: theme?.resType?.chooseTextHover,
                    },
                  }}
                  onClick={() => {
                    handleSelect(item);
                    handleClose();
                  }}
                >
                  <AddCircleTwoToneIcon />
                </IconButton>
              </Box>
            </Box>
          </>
        ))}
      </Box>
    </Popover>
  );
};

export default EventOrStandardReservationType;
